'use strict';
import $ from 'jquery';
//import setEnquire from 'enquire';
//setEnquire($);
export default class Menu {
	constructor() {
		if ($("nav").length > 0) {

			$(window).on("orientationchange", function (e) {
				if (window.matchMedia("(orientation: portrait)").matches) {
					$('footer ul').hide();
					$('.is-open').removeClass('is-open');
				}
				else {
					//pageSetup();
					$('footer ul').show();
				}
			})

			if ($(window).outerWidth() <= 1024) {
				// open close mobile menu
				$('.mobile-menu').on('click', function (e) {
					var $menuIsOpen = $('header').hasClass('is-active');
					if ($('.block-search').hasClass('is-active')) {
						setTimeout(function () {
							$('.block-search').removeClass('is-active');
							$('.search-btn').removeClass('is-active');
						}, 300);
					}
					if ($menuIsOpen) {
						$('.icon-holder').hide();
						$('.menu--mgs-main-navigation,.menu--quick-links-mobile').slideUp();
						$('header').removeClass('is-active');
						$('body').removeClass('lock');
					}
					else {
						setTimeout(function () {
							$('.icon-holder').fadeIn('fast');
						}, 300);
						setTimeout(function () {
							$('.menu--mgs-main-navigation,.menu--quick-links-mobile').slideDown();
							$('header').addClass('is-active');
							$('body').addClass('lock');
						}, 200);
					}
				})
				$(window).on('scroll', function () {
					var $scrollPos = $(window).scrollTop();
					if ($scrollPos <= 55) {
						$('header').removeClass('fixed');
					}
					else {
						$('header').addClass('fixed');
					}
				}).off('scroll', function () {
					return false;
				});
				// Open and close sections
				$('.menu_toggle').on('click', function (e) {
					e.preventDefault;
					var $this = $(this)
						, $parent = $this.parent()
						, $target = $this.next('ul');

					if ($target.is(':visible')) {
						$target.slideUp();
						$parent.removeClass('is-open');
						$parent.find('.is-open').removeClass('is-open');
						$parent.find('ul:visible').slideUp();
					} else if ($parent.parent().hasClass('menu-l1')) {
						$('.is-open').removeClass('is-open');
						$('.menu-l1 ul:visible').slideUp();
						$target.slideDown();
						$this.parent().addClass('is-open');
					} else {
						$target.slideDown();
						$this.parent().addClass('is-open');
					}
				});


			} else { // desktop
				//pageSetup();
                $('#desktop-search-btn').on('click', function () {
                    if ($('#desktop-search-btn').hasClass('is-active')) {
                        console.log('dfdsafdsa');
                        $('.menu-l1_link').css('pointer-events','none');
                    }else{
                        $('.menu-l1_link').css('pointer-events','unset');
					}
                });

				$('.is-open').each(function () {
					if ($(this).children('ul').length == 0) {
						$(this).removeClass('is-open')
					};
				});
				$('.quick-links-nav .menu').on('mouseover', function () {
					if (!$(this).hasClass('is-open')) {
						$('.quick-links-nav .menu').removeClass('is-open');
						$(this).addClass('is-open');
					}
				})

				var $timer;
				$('.main-nav .menu-l1_link').on('mouseover', function () {
					if ( $timer ) clearTimeout($timer);
					var thisMenuItem = $(this);
					$timer = setTimeout(function(){
						if (!thisMenuItem.hasClass('active')) {
							$('.main-nav .menu-l2').fadeOut();
							thisMenuItem.parent().find('.menu-l2').fadeIn().css('display', 'flex');
							//console.log(thisMenuItem);
							clearTimeout($timer);
						}
					}, 150);
				});
				$('body').on('mouseover', function (e) {
					var $eTarget = $(e.target);
					if (!$eTarget.hasClass('navigation') && !$eTarget.parents('.main-nav').length) {
						$('.main-nav .menu-l2').fadeOut();
					}
					if (!$eTarget.hasClass('menu') && !$eTarget.parents('.quick-links-nav').length) {
						$('.quick-links-nav .menu').removeClass('is-open');
					}
				});
				$('.main-nav .menu-l2').each(function () {
					var maxHeight;
					$(this).find('.menu-l3').each(function () {
						maxHeight = maxHeight > $(this).height() ? maxHeight : $(this).height();
						$(this).height(maxHeight);
					});
					$(this).css({
						"display": "none"
						, "opacity": "1"
					});
				});
				// make news listing the same height
				$('.view-news-listing').each(function () {
					var maxHeight;
					$(this).find('.details').each(function () {
						maxHeight = maxHeight > $(this).height() ? maxHeight : $(this).height();
						$(this).height(maxHeight);
					});
				});
				// Open and close sections
				$('.layout-sidebar-left').find('.menu_toggle').on('click', function (e) {
					e.preventDefault;
					var $this = $(this)
						, $parent = $this.parent()
						, $target = $this.next('ul');
					menu($this, $parent, $target);
				});

				function menu($this, $parent, $target) {
					var ua = window.navigator.userAgent;
					var msie = ua.indexOf("MSIE");

					if ($target.is(':visible')) {
						$target.slideUp();
						$parent.removeClass('is-open');
						$parent.find('.is-open').removeClass('is-open');
						$parent.find('ul:visible').slideUp();
					} else if ($parent.parent().hasClass('menu-l1')) {
						$('.is-open').removeClass('is-open');
						$('.menu-l1 ul:visible').slideUp();

						if (msie){
							$target.show();
						} else {
							$target.slideDown();
						}

						$this.parent().addClass('is-open');
					} else {

						if (msie){
							$target.show();
						} else {
							$target.slideDown();
						}

						$this.parent().addClass('is-open');
					}
				}

				$(window).on('scroll', function () {
					var $scrollPos = $(window).scrollTop();
					if ($scrollPos < 75) {
						$('header').removeClass('fixed');
					}
					else {
						$('header').addClass('fixed');
					}
				}).off('scroll', function () {
					return false;
				});
			}


		}
	}
}
